export const getTagColor = (current, index) => {
  if (index <= current) {
    return "blue";
  }
  return "default";
};

export const getAvatarColor = (current, index) => {
  if (index <= current) {
    return "#0E2483";
  }
  return "default";
};
